"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    us: 'NA',
    cl: 'NA',
    hn: 'NA',
    ca: 'NA',
    co: 'NA',
    ni: 'NA',
    mx: 'NA',
    cr: 'NA',
    pa: 'NA',
    br: 'NA',
    ec: 'NA',
    py: 'NA',
    ar: 'NA',
    sv: 'NA',
    pe: 'NA',
    bo: 'NA',
    gt: 'NA',
    uy: 'NA',
    au: 'AU',
    nz: 'NZ',
    at: 'AT',
    bh: 'BH',
    be: 'BE',
    bg: 'BG',
    hr: 'HR',
    cy: 'CY',
    cz: 'CZ',
    dk: 'DK',
    fi: 'FI',
    fr: 'FR',
    de: 'DE',
    gr: 'GR',
    hu: 'HU',
    is: 'IS',
    in: 'IN',
    ie: 'IE',
    il: 'IL',
    it: 'IT',
    kw: 'KW',
    lb: 'LB',
    lu: 'LU',
    mt: 'MT',
    nl: 'NL',
    no: 'NO',
    om: 'OM',
    pl: 'PL',
    pt: 'PT',
    qa: 'QA',
    ro: 'RO',
    ru: 'RU',
    sa: 'SA',
    sk: 'SK',
    si: 'SI',
    za: 'ZA',
    es: 'ES',
    se: 'SE',
    ch: 'CH',
    tr: 'TR',
    ae: 'AE',
    gb: 'GB',
    ua: 'UA',
    th: 'ASIA',
    kr: 'ASIA',
    my: 'ASIA',
    id: 'ASIA',
    ph: 'ASIA',
    sg: 'ASIA',
    jp: 'JAPAN'
};
//# sourceMappingURL=PsnContryRegionMapping.js.map